import { createContext, useContext } from "react";

/**
 * O que a tabela da EAP precisa entregar a CADA linha, em qualquer profundidade
 * (unidade → célula → etapa → subetapa → serviço). Passar por prop atravessaria cinco
 * componentes de accordion só para chegar na linha; o contexto local mantém os
 * accordions iguais aos da Projeção Financeira — só montam o nível seguinte.
 */
export const EapTableContext = createContext({
  readOnly: true,
  rulesByNodeKey: {},
  onEditRule: null,
  // O recorte por meses selecionados no gráfico (`Set<"AAAA-MM">`, vazio = EAP completa) e a
  // gravação do ajuste a partir dele: `onSliceAdjust(wbsCodeId, lines, toCompetence,
  // description)` devolve `{ ok, message? }`.
  selectedMonths: new Set(),
  onSliceAdjust: null,
  // Como a linha sem regra própria se rotula quando a origem já traz distribuição no tempo
  // ("Segue o desembolso do ERP"). Sem ele (origem desconhecida), o rótulo antigo.
  followsLabel: null,
  // A origem "criar do zero" (D12): `{ distributions: Map<nó, { startMonth, profile }>, roots,
  // onSave(wbsCodeId, distribution | null) → { ok, message? } }`. Ausente nas outras origens.
  distributionEditor: null,
});

export const useEapTable = () => useContext(EapTableContext);
